// src/components/LanguageProvider.js
import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext({
  locale: "en",
  toggleLanguage: () => {},
});

const LanguageProvider = ({ children }) => {
  const getLocaleFromUrl = () => {
    if (typeof window === "undefined") return null;
    const pathLocale = window.location.pathname.split("/")[1];
    return ["pl", "en"].includes(pathLocale) ? pathLocale : null;
  };

  const getUserPreferredLocale = () => {
    if (typeof window === "undefined") return "en";

    // Sprawdzamy, czy użytkownik ma zapisany język w localStorage
    const storedLocale = localStorage.getItem("preferredLocale");
    if (storedLocale) return storedLocale;

    // Pobieramy język z URL
    const urlLocale = getLocaleFromUrl();
    if (urlLocale) return urlLocale;

    // Pobieramy język z przeglądarki
    const browserLocale = navigator.language.split("-")[0];
    return browserLocale === "pl" ? "pl" : "en"; // Domyślnie ustawiamy "en"
  };

  const [locale, setLocale] = useState(getUserPreferredLocale);

  const toggleLanguage = () => {
    const newLocale = locale === "pl" ? "en" : "pl";
    setLocale(newLocale);

    // Zapamiętujemy język użytkownika
    localStorage.setItem("preferredLocale", newLocale);

    // Zmieniamy URL tylko jeśli użytkownik kliknie przełącznik języka
    const newPath = `/${newLocale}${window.location.pathname.replace(/^\/(pl|en)/, "")}`;
    window.location.assign(newPath);
  };

  useEffect(() => {
    const urlLocale = getLocaleFromUrl();

    // Jeżeli użytkownik nie ma prefiksu języka w URL, ustawiamy domyślny język (ale bez przekierowania na /en)
    if (!urlLocale) {
      const preferredLocale = getUserPreferredLocale();
      setLocale(preferredLocale);
    } else {
      setLocale(urlLocale);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ locale, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
